//namespace
window.QJTApp = window.QJTApp || { modules: {} };

QJTApp.modules.home 						= QJTApp.modules.home || {};
QJTApp.modules.home.models 			= QJTApp.modules.home.models || {};
QJTApp.modules.home.views 			= QJTApp.modules.home.views || {};
QJTApp.modules.home.collections = QJTApp.modules.home.collections || {};
QJTApp.modules.home.routes      = QJTApp.modules.home.routes || {};

QJTApp.modules.home.collections.ItemsCollection = Backbone.Collection.extend({

  model: QJTApp.modules.home.models.SingleItem,

  initialize: function(){
  	//console.log('Collection - ItemsCollection initialized!');
  }

  //polimorfismo
  /*model: function(attrs, options) {
    if (condition) {
      return new PublicDocument(attrs, options);
    } else {
      return new PrivateDocument(attrs, options);
    }
  }*/

});